import styled from 'styled-components';
import { Fonts } from '@prezi/dragon';
import { $switchCaseStrict } from 'dolla-switch';
import { ButtonSize, ButtonTheme } from './Button';

type Props = {
    size: ButtonSize;
    theme: ButtonTheme;
    border?: boolean;
    isActive?: boolean;
    disabled?: boolean;
    isFullWidth?: boolean;
};

export const WrappingAnchor = styled.a<Props>`
    && {
        display: inline-flex;
        align-items: center;
        cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
        justify-content: ${props => (props.isFullWidth ? 'center' : 'flex-start')};
        min-height: ${props => (props.size === 'large' ? '38px' : '32px')};
        padding: 0 13px;
        ${props => (props.isFullWidth ? 'width: 100%;' : '')}
        border: 1px solid ${props => (props.border ? props.theme.bgHoverColor : props.theme.bgColor)};

        ${({ size }) =>
            $switchCaseStrict(size, {
                small: () => `border-radius: 4px;`,
                medium: () => `border-radius: 6px;`,
                large: () => `border-radius: 6px;`,
            })};

        color: ${props => props.theme.fgColor};
        background-color: ${props => (props.isActive ? props.theme.bgHoverColor : props.theme.bgColor)};
        font-family: ${Fonts.ralewaySemiBold};
        font-size: 13px;
        line-height: 0;
        white-space: normal;
        transition: background-color 0.2s ease, border-color 0.2s ease;
        text-decoration: none;

        &:hover {
            background-color: ${props => props.theme.bgHoverColor};
            border-color: ${props => props.theme.bgHoverColor};
            text-decoration: none;
        }

        ${props => props.disabled && `outline: none;`}
    }
`;
